// SUMMARY: Shared layout width tokens. The dashboard shell and the fixed header must agree on their
// max width or the header stops lining up with the content beneath it - so both read it from here.

// TRIAL (2026-08-17): dashboard runs edge-to-edge. Revert = set this back to 'max-w-[1600px]'.
export const DASHBOARD_MAX_WIDTH = 'max-w-none'

// The chat reading column (messages + composer + empty state, main chat AND the fresh lab). It stays
// capped on purpose - the shell may be edge-to-edge, but prose past ~120 characters a line gets hard to
// track. Narrowed 2026-08-18 from 76/88rem, which ran the full bubble width across a wide desktop; the
// 2xl step now only opens up a little rather than doubling down on the width. Widen/narrow HERE so all
// six wrappers can never drift apart.
export const CHAT_COLUMN_WIDTH = 'max-w-[56rem] 2xl:max-w-[62rem]'

// Settings-style pages (settings/*, CLI, API keys): a centered reading column instead of the shell's
// edge-to-edge width - forms and single-column cards look lost stretched across a wide monitor. Full
// width on phones/tablets, then ~3/4 from lg and ~3/5 from xl, capped so an ultrawide stays sane.
// Admin pages (analytics, database, papers …) deliberately do NOT use this - they are dense tables.
export const SETTINGS_COLUMN_WIDTH = 'mx-auto w-full max-w-[76rem] lg:w-4/5 xl:w-3/5'
